import { createTheme } from '@mui/material/styles';
import { remCalc } from 'utils/remCalc';
import breakpoints from 'utils/breakpoints';
import mixins from 'utils/mixins';
import { getColor } from 'utils/colors';

const theme = createTheme({
	breakpoints: breakpoints,
	mixins: mixins,
});

export const overrides = {
	'.multiCTACard__section': {
		...theme.mixins.layout_styles,
		position: 'relative',
		'.multiCTACard__bg_image': {
			position: 'absolute',
			bottom: 0,
			left: 0,
			width: '100%',
			height: remCalc('219px'),
			zIndex: 1,
			backgroundSize: 'cover',
			backgroundRepeat: 'no-repeat',
			backgroundPosition: 'center',
			// transition: 'all .2s ease-in-out',
			// clipPath: 'polygon(0 0, 100% 0%, 100% 100%, 0 100%)',
			// clipPath: 'polygon(200px 0, 717px 0%, 717px 100%, 200px 100%)',
			transitionTimingFunction: 'var(--transition-timing)',
			transitionProperty: 'clip-path, height, background',
			transitionDuration: 'var(--transition-duration-slow), var(--transition-duration-slow), var(--transition-duration-slow)',
			[theme.breakpoints.down('md')]: {
				clipPath: 'none!important',
			},
			[theme.breakpoints.up('md')]: {
				top: 0,
				height: '100%',
			},
			'.multiCTACard__image_slide': {
				backgroundSize: 'cover',
				backgroundRepeat: 'no-repeat',
				backgroundPosition: 'center',
			}
		},
		'.multiCTACard__content_grid': {
			[theme.breakpoints.down('md')]: {
				padding: remCalc('20px 15px 260px'),
			},
			[theme.breakpoints.up('md')]: {
				minHeight: 'calc(100vh - 200px)',
			},
			'.multiCTACard__text_wrap': {
				position: 'relative',
				zIndex: 2,
				transition: 'all var(--transition-duration-slow) var(--transition-timing)',
				color: getColor('ivory', 700),
				[theme.breakpoints.up('md')]: {
					paddingRight: remCalc('150'),
				},
				'.multiCTACard__title': {
					textTransform: 'uppercase',
					lineHeight: remCalc('32px'),
					[theme.breakpoints.up('md')]: {
						lineHeight: remCalc('54px'),
					}
				}, 
				'.multiCTACard__sub_title': {
					marginTop: remCalc('16px'),
					fontStyle: 'italic',
					fontWeight: 500,
				},
				'.multiCTACard__links': {
					marginTop: remCalc('30px'),
					display: 'flex',
					flexDirection: 'column',
					gap: remCalc('24px'),
					alignItems: 'flex-start',
					[theme.breakpoints.up('md')]: {
						marginTop: remCalc('96px'),
					},
					'.multiCTACard__link': {
						color: getColor('ivory', 700),
						textDecoration: 'none',
						textTransform: 'uppercase',
						display: 'inline-flex',
						flexDirection: 'column',
						transitionTimingFunction: 'var(--transition-timing)',
						transitionProperty: 'opacity, color, padding',
						transitionDuration: 'var(--transition-duration-slow), var(--transition-duration-slow), var(--transition-duration)',
						'&:after': {
							content: '""',
							width: '100%',
							backgroundColor: getColor('ivory', 700),
							height: remCalc('1px'),
							transition: 'width var(--transition-duration) var(--transition-timing)'
						}
					}
				}
			},
			'.multiCTACard__image_space': {
				height: '100%',
				[theme.breakpoints.down('md')]: {
					display: 'none',
				}
			}
		},
		'&.active': {
			'.multiCTACard__bg_image': {
				[theme.breakpoints.down('md')]: {
					height: '100%',
				}
			},
			'.multiCTACard__content_grid': {
				'.multiCTACard__text_wrap': {
					color: getColor('white',100),
					'.multiCTACard__links': {
						'.multiCTACard__link': {
							color: getColor('white', 700),
							'&:after': {
								backgroundColor: getColor('white', 700),
							},
							[theme.breakpoints.up('md')]: {
								// opacity: '.4',
								'&:hover': {
									// opacity: '1',
									'&:after': {
										width: 'calc(100% + 70px)',
									},
								}
							}
						}
					}
				}
			}
		}
	}
}

const styles = {};

export default styles;